// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__EKVgJ","rootCenter":"LoadMoreObserver_rootCenter__13xuT","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1Z0x2"};